import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShoppingCart,
  faLightbulb,
  faAngleRight,
  faAngleLeft,
  faCheck,
  faLongArrowAltLeft,
  faHeadset,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAngleLeft,
  faAngleRight,
  faShoppingCart,
  faLightbulb,
  faCheck,
  faLongArrowAltLeft,
  faHeadset,
  faQuestionCircle
)

export const Icon = (props) => {
  return(
    <FontAwesomeIcon {...props} />
  );
}

export default Icon;
